import {
  CarFront,
  ClipboardCheck,
  ConciergeBell,
  FileCheck2,
  Home,
  PackageCheck,
  ShipWheel,
} from "lucide-react";

export const services = [
  {
    slug: "automobile-services",
    cardTitle: "Automobile Services",
    shortTitle: "Automobiles",
    title: "Automobile services, handled end to end",
    navTitle: "Automobile services",
    icon: CarFront,
    accent: "ocean",
    description:
      "From a trusted vehicle search to the keys in your hands, our operations team coordinates every important step across borders.",
    bullets: [
      "Vehicle sourcing from the US, UK, Canada and Europe",
      "Pre-purchase inspection and negotiation support",
      "Shipping, customs clearing, registration and delivery",
    ],
    workflow: [
      "Share your specification and budget",
      "Review verified options and inspection notes",
      "Approve, fund milestones and receive delivery updates",
    ],
  },
  {
    slug: "logistics",
    cardTitle: "Logistics",
    shortTitle: "Logistics",
    title: "Logistics that keep your world moving",
    navTitle: "Logistics",
    icon: PackageCheck,
    accent: "cyan",
    description:
      "A single accountable team for freight, warehousing, consolidation, domestic delivery and clear shipment visibility.",
    bullets: [
      "Freight forwarding and cargo consolidation",
      "Warehousing and last-mile delivery",
      "Shipment tracking and delivery confirmation",
    ],
    workflow: [
      "Submit your shipment details",
      "Receive a clear scope, price and timeline",
      "Track each handoff until delivery",
    ],
  },
  {
    slug: "clearing-and-forwarding",
    cardTitle: "Clearing and Forwarding",
    shortTitle: "Clearing & forwarding",
    title: "Clear the complexity at the border",
    navTitle: "Clearing & forwarding",
    icon: ShipWheel,
    accent: "bridge",
    description:
      "We make customs documentation, duty assessment, port clearance and release coordination easier to understand and execute.",
    bullets: [
      "Customs documentation preparation",
      "Duty assessment and clearance coordination",
      "Port release updates and handover",
    ],
    workflow: [
      "We review your cargo and documents",
      "Our team maps the clearance path",
      "You receive progress updates and release evidence",
    ],
  },
  {
    slug: "real-estate-services",
    cardTitle: "Real Estate Services",
    shortTitle: "Real estate",
    title: "Property decisions with more certainty",
    navTitle: "Real estate services",
    icon: Home,
    accent: "ocean",
    description:
      "Whether you are buying from abroad or managing a project locally, we bring structured due diligence and on-ground accountability.",
    bullets: [
      "Property sourcing against your criteria",
      "Title verification and due diligence",
      "Construction supervision and property management",
    ],
    workflow: [
      "Define your location, budget and use case",
      "Review sourced opportunities and reports",
      "Proceed with confidence or keep searching",
    ],
  },
  {
    slug: "concierge-services",
    cardTitle: "Concierge Services",
    shortTitle: "Concierge",
    title: "A capable local hand when you need one",
    navTitle: "Concierge services",
    icon: ConciergeBell,
    accent: "bridge",
    description:
      "From airport pickup to event support, our team handles the practical details so you can focus on why you are here.",
    bullets: [
      "Airport pickup and accommodation arrangements",
      "Errand management and VIP support",
      "Event coordination and completion evidence",
    ],
    workflow: [
      "Tell us what success looks like",
      "Receive the plan, price and timeline",
      "Stay informed while the task is completed",
    ],
  },
  {
    slug: "procurement-management",
    cardTitle: "Procurement Management as a Service (PMaaS)",
    shortTitle: "Procurement",
    title: "Procurement management as a service",
    navTitle: "Procurement management (PMaaS)",
    icon: ClipboardCheck,
    accent: "cyan",
    description:
      "A disciplined extension of your team for vendor sourcing, RFQs, negotiation, purchase orders and supplier performance.",
    bullets: [
      "Requirement definition and vendor sourcing",
      "RFQ management and price negotiation",
      "Purchase order administration and delivery monitoring",
    ],
    workflow: [
      "Share the requirement and guardrails",
      "We collect, compare and recommend",
      "You approve while we manage execution",
    ],
  },
  {
    slug: "regulatory-compliance",
    cardTitle: "Regulatory Compliance Support",
    shortTitle: "Compliance",
    title: "Regulatory confidence for growing organisations",
    navTitle: "Regulatory compliance",
    icon: FileCheck2,
    accent: "bridge",
    description:
      "Keep business registration, permits, filings and supporting documentation moving with a clear operational owner.",
    bullets: [
      "Business registration support",
      "Permit processing and regulatory filings",
      "Documentation advisory and status reporting",
    ],
    workflow: [
      "We understand your entity and obligations",
      "Our team prepares and tracks the work",
      "You receive a clean record of completed work",
    ],
  },
];

export const getService = (slug) =>
  services.find((service) => service.slug === slug);

export const serviceGroups = [
  {
    title: "Move",
    description: "Vehicles and goods, coordinated across borders.",
    services: services.slice(0, 3),
  },
  {
    title: "Manage",
    description: "Local execution for people, property and projects.",
    services: services.slice(3, 5),
  },
  {
    title: "Grow",
    description: "Procurement and compliance for organisations.",
    services: services.slice(5),
  },
];
